/* eslint key-spacing: 'off', comma-spacing: 'off' */
import current from '@/scripts/current';
import store from '@/store';

export default {
    //years: 'years',
    //location: 'location',
    //rowvariable: 'rowvariable',
    //columnvariable: 'columnvariable',
    //controlvariables: 'controlvariables',
    //statistics: 'statistics',
    //viewreport: 'viewreport'
    getHelpState: function (selectionModel) {
        var singleYearSelected = store.state.selModel.years.selectionType == 'single' && store.state.selModel.years.single > 0;
        var combiningYears = store.state.selModel.years.selectionType === 'combine' && store.state.selModel.years.values.length >= 2;
        var comparingYears = store.state.selModel.years.selectionType === 'compare' && store.state.selModel.years.values.length >= 2;
        const locations = store.state.selModel.locations;
        var singleLocationSelected = locations.selectionType === 'single' && locations.allIds.length === 1;
        var combiningLocations = locations.selectionType === 'combine' && locations.allIds.length >= 2;
        var comparingLocations = locations.selectionType === 'compare' && locations.allIds.length >= 2;

        var rowIsYear = current.selectionModel.v.row.type === 'year';
        var columnIsYear = current.selectionModel.v.column.type === 'year';
        var control1IsYear = current.selectionModel.v.control1.type === 'year';
        var control2IsYear = current.selectionModel.v.control2.type === 'year';
        var rowIsLocation = current.selectionModel.v.row.type === 'location';
        var columnIsLocation = current.selectionModel.v.column.type === 'location';
        var control1IsLocation = current.selectionModel.v.control1.type === 'location';
        var control2IsLocation = current.selectionModel.v.control2.type === 'location';
        var v = current.selectionModel.v;
        var state = {
            step: current.selectionModel.currentStep,
            singleYearSelected: singleYearSelected,
            combiningYears: combiningYears,
            comparingYears: comparingYears,
            justSelectedYear: singleYearSelected || combiningYears || comparingYears,
            hasYearBeenAssigned: rowIsYear || columnIsYear || control1IsYear || control2IsYear,
            singleLocationSelected: singleLocationSelected,
            combiningLocations: combiningLocations,
            comparingLocations: comparingLocations,
            justSelectedLocation: singleLocationSelected || combiningLocations || comparingLocations,
            hasLocationBeenAssigned: rowIsLocation || columnIsLocation || control1IsLocation || control2IsLocation,
            isRowSelected: v.row.isSelected(),
            isColumnSelected: v.column.isSelected(),
            isControl1Selected: v.control1.isSelected(),
            isControl2Selected: v.control2.isSelected(),
            rowIsYear: rowIsYear,
            columnIsYear: columnIsYear,
            control1IsYear: control1IsYear,
            control2IsYear: control2IsYear,
            rowIsLocation: rowIsLocation,
            columnIsLocation: columnIsLocation,
            control1IsLocation: control1IsLocation,
            control2IsLocation: control2IsLocation
        };
        return state;
    }
}
